import { t } from './i18n'
// 新功能卡片的内容。登录后打开网站，没看过的条目会弹出来（components/WhatsNew.tsx）。
//
// 加一条：把新条目放在数组**最前面**，id 起个新的、永远不要复用 —— 看过的记录按 id 存，
// 复用旧 id 等于对看过的人静默。每条只写三样：标题、一句话说它是什么（intro）、一个例子（example），
// 再加一个去哪试（cta）。要短 —— 这是弹在脸上的提示，不是说明书，写不下的放文档里。
//
// 只写**新功能**：修 bug、改性能、重构都不进这里，用户不需要被它们打断。
// 功能是 asaptodo 这个站自己的能力，不是某个页面的功能；cta 只在有一个具体页面能马上试
// 的时候才给，没有就别硬凑一个（不要为了有按钮把人带到不相干的页面）。
//
// 数据放在文件里而不是数据库：更新跟着功能的 PR 一起提交，不会漏。

export type UpdateEntry = {
  id: string
  date: string
  tag: string
  title: string
  intro: string
  example: string
  cta?: { label: string; href: string }
}

export const UPDATES: UpdateEntry[] = [
  {
    id: '2026-11-05-artifact-search',
    date: '2026-11-05',
    tag: 'Artifact',
    title: t('公开的 artifact 能被搜到了', 'Public artifacts can show up in search'),
    intro: t(
      '分享面板里勾上「允许搜索引擎收录」，Google、Bing 就能搜到它。不勾也有好处：链接发到微信、Slack 会带上标题和缩略图。',
      'Tick “Let search engines list it” in the Share panel and Google and Bing can find it. Even unticked, links you paste into WeChat or Slack now show a title and thumbnail.',
    ),
    example: t('一张公开的单词卡 → 勾上 → 有人搜这个词时能找到它', 'A public vocabulary card → tick it → people searching that word can find it'),
  },
  {
    id: '2026-11-04-bilingual-ui',
    date: '2026-11-04',
    tag: t('界面', 'Interface'),
    title: t('支持英文界面了', 'asaptodo now speaks English'),
    intro: t(
      '点顶栏右上角的「EN」切到英文，再点「中文」切回来。登录后会记在账号里，换设备也一样。',
      'Click 中文 in the top bar to switch to Chinese, and EN to switch back. Signed in, your choice follows you across devices.',
    ),
    example: t('顶栏 EN → 整站变英文', 'Top bar 中文 → the whole site in Chinese'),
    cta: { label: t('去设置', 'Open Settings'), href: '/settings' },
  },
  {
    id: '2026-10-30-input-center-collapse',
    date: '2026-10-30',
    tag: t('待办', 'Todo'),
    title: t('输入条收起来了，在顶栏右上角', 'The input bar now lives in the top-right corner'),
    intro: t(
      '它不再一直占着屏幕底部。按 ⌘K（Windows 是 Ctrl+K）或点右上角那只小豆子就能叫回来。',
      'It no longer takes up the bottom of the screen. Press ⌘K (Ctrl+K on Windows) or click the little bean in the top right to bring it back.',
    ),
    example: t('⌘K → 写一件事 → 回车', '⌘K → type a task → Enter'),
    cta: { label: t('去试试', 'Try it'), href: '/todo/today' },
  },
  {
    id: '2026-10-29-shared-tool-data',
    date: '2026-10-29',
    tag: 'Recipe',
    title: t('Recipe 可以大家一起用了', 'Recipes can now be shared by everyone'),
    intro: t(
      '发布时选「大家一起用」，你勾选的内容，所有添加的人都能看到。',
      'Choose "Shared by everyone" when publishing, and everyone who adds it sees what you check off.',
    ),
    example: t('每日打卡里显示「今天 37 人打卡」', 'A daily check-in shows "37 people checked in today"'),
  },
  {
    id: '2026-10-28-input-center',
    date: '2026-10-28',
    tag: t('待办', 'Todo'),
    title: t('底部「一句话」输入条', 'One-line input bar at the bottom'),
    intro: t('按 / 唤起，写一句话就能记事、查事、改事。', 'Press / to open it. One line to add, find or change tasks.'),
    example: t('明天下午 交周报 #工作 !1', 'Send weekly report tomorrow afternoon #work !1'),
    cta: { label: t('去试试', 'Try it'), href: '/todo/today' },
  },
  {
    id: '2026-10-27-ai-cowork-time',
    date: '2026-10-27',
    tag: t('工作日志', 'Worklog'),
    title: t('AI 共创时间', 'AI co-working time'),
    intro: t('工作日志自动记下和 AI 干了多久，需要升级 hook。', 'Worklogs now record how long you worked with AI. Requires a hook upgrade.'),
    example: t('问 AI「这周时间花在哪了」', 'Ask AI "Where did my time go this week?"'),
    cta: { label: t('去看看', 'Take a look'), href: '/worklog' },
  },
  {
    id: '2026-10-22-todo-layout',
    date: '2026-10-22',
    tag: t('待办', 'Todo'),
    title: t('待办页：详情栏可拖宽，项目可折叠', 'Todo: resizable detail pane, collapsible projects'),
    intro: t('拖详情栏的边缘调宽，点左边的「项目」收起。', 'Drag the detail pane edge to resize; click "Projects" on the left to collapse.'),
    example: t('长任务描述拖宽就不用来回滚', 'Widen it to read long task descriptions without scrolling'),
    cta: { label: t('去试试', 'Try it'), href: '/todo/today' },
  },
]
